export const MCQSingleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0479 6.35159C20.2729 6.57662 20.3993 6.88179 20.3993 7.19999C20.3993 7.51819 20.2729 7.82335 20.0479 8.04839L10.4479 17.6484C10.2229 17.8734 9.91771 17.9997 9.59951 17.9997C9.28131 17.9997 8.97614 17.8734 8.75111 17.6484L3.95111 12.8484C3.73252 12.6221 3.61157 12.3189 3.6143 12.0043C3.61704 11.6897 3.74324 11.3887 3.96573 11.1662C4.18822 10.9437 4.48919 10.8175 4.80383 10.8148C5.11847 10.812 5.42159 10.933 5.64791 11.1516L9.59951 15.1032L18.3511 6.35159C18.5761 6.12662 18.8813 6.00024 19.1995 6.00024C19.5177 6.00024 19.8229 6.12662 20.0479 6.35159Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const MCQMultiIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2952 7.70509C17.6845 7.31573 17.6845 6.68445 17.2952 6.29509C16.9058 5.90573 16.2745 5.90573 15.8852 6.29509L10.9552 11.2251C10.5658 11.6144 10.5658 12.2457 10.9552 12.6351C11.3445 13.0244 11.9758 13.0244 12.3652 12.6351L17.2952 7.70509ZM22.9476 6.2926C22.5567 5.90443 21.9251 5.90515 21.5355 6.2947L12.3664 15.4638C11.9762 15.854 11.3437 15.8544 10.9531 15.4647L8.18558 12.7038C7.79585 12.315 7.16484 12.3154 6.77558 12.7047C6.38598 13.0943 6.38598 13.7259 6.77558 14.1155L10.953 18.293C11.3436 18.6835 11.9767 18.6835 12.3673 18.293L22.9505 7.7097C23.342 7.3182 23.3405 6.68271 22.9476 6.2926ZM1.12235 12.7029C0.729466 13.093 0.728266 13.7282 1.11977 14.1197L5.29484 18.2948C5.68438 18.6843 6.31594 18.6843 6.70547 18.2948C7.09476 17.9055 7.09504 17.2744 6.7061 16.8848L2.53477 12.706C2.14532 12.3158 1.51352 12.3145 1.12235 12.7029Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const YesNoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.40039 12.5999C2.40039 12.3635 2.44695 12.1295 2.53741 11.9111C2.62787 11.6927 2.76045 11.4943 2.9276 11.3271C3.09474 11.16 3.29317 11.0274 3.51156 10.9369C3.72995 10.8465 3.96401 10.7999 4.20039 10.7999C4.43677 10.7999 4.67083 10.8465 4.88922 10.9369C5.10761 11.0274 5.30604 11.16 5.47318 11.3271C5.64033 11.4943 5.77292 11.6927 5.86337 11.9111C5.95383 12.1295 6.00039 12.3635 6.00039 12.5999V19.7999C6.00039 20.2773 5.81075 20.7351 5.47318 21.0727C5.13562 21.4103 4.67778 21.5999 4.20039 21.5999C3.723 21.5999 3.26516 21.4103 2.9276 21.0727C2.59003 20.7351 2.40039 20.2773 2.40039 19.7999V12.5999ZM7.20039 12.3995V18.9155C7.20018 19.3615 7.32425 19.7987 7.55869 20.1781C7.79312 20.5576 8.12863 20.8641 8.52759 21.0635L8.58759 21.0935C9.25345 21.4263 9.98759 21.5997 10.732 21.5999H17.2312C17.7862 21.6001 18.3242 21.408 18.7535 21.0561C19.1827 20.7043 19.4768 20.2146 19.5856 19.6703L21.0256 12.4703C21.0952 12.1221 21.0867 11.7629 21.0006 11.4184C20.9146 11.074 20.7532 10.7529 20.5282 10.4783C20.3031 10.2037 20.0199 9.98254 19.6989 9.83065C19.378 9.67875 19.0274 9.59994 18.6724 9.5999H14.4004V4.7999C14.4004 4.16338 14.1475 3.55293 13.6974 3.10285C13.2474 2.65276 12.6369 2.3999 12.0004 2.3999C11.6821 2.3999 11.3769 2.52633 11.1519 2.75137C10.9268 2.97642 10.8004 3.28164 10.8004 3.5999V4.4003C10.8004 5.43888 10.4635 6.44944 9.84039 7.2803L8.16039 9.5195C7.53724 10.3504 7.20039 11.3609 7.20039 12.3995Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const ShortTextIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.59961 8.39995C3.59961 8.08169 3.72604 7.77647 3.95108 7.55142C4.17612 7.32638 4.48135 7.19995 4.79961 7.19995H19.1996C19.5179 7.19995 19.8231 7.32638 20.0481 7.55142C20.2732 7.77647 20.3996 8.08169 20.3996 8.39995C20.3996 8.71821 20.2732 9.02344 20.0481 9.24848C19.8231 9.47352 19.5179 9.59995 19.1996 9.59995H4.79961C4.48135 9.59995 4.17612 9.47352 3.95108 9.24848C3.72604 9.02344 3.59961 8.71821 3.59961 8.39995ZM3.59961 15.5999C3.59961 15.2817 3.72604 14.9765 3.95108 14.7514C4.17612 14.5264 4.48135 14.4 4.79961 14.4H19.1996C19.5179 14.4 19.8231 14.5264 20.0481 14.7514C20.2732 14.9765 20.3996 15.2817 20.3996 15.5999C20.3996 15.9182 20.2732 16.2234 20.0481 16.4485C19.8231 16.6735 19.5179 16.7999 19.1996 16.7999H4.79961C4.48135 16.7999 4.17612 16.6735 3.95108 16.4485C3.72604 16.2234 3.59961 15.9182 3.59961 15.5999Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const LongTextIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H20H4ZM4 12H20H4ZM4 18H20H4Z"
      className="svgicon-tprimary fill"
    />
    <path
      d="M4 18H20M4 6H20H4ZM4 12H20H4Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon-tprimary stroke"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.20039 2.3999C6.88213 2.3999 6.57691 2.52633 6.35186 2.75137C6.12682 2.97642 6.00039 3.28164 6.00039 3.5999V4.7999H4.80039C4.16387 4.7999 3.55342 5.05276 3.10333 5.50285C2.65325 5.95293 2.40039 6.56338 2.40039 7.1999V19.1999C2.40039 19.8364 2.65325 20.4469 3.10333 20.897C3.55342 21.347 4.16387 21.5999 4.80039 21.5999H19.2004C19.8369 21.5999 20.4474 21.347 20.8974 20.897C21.3475 20.4469 21.6004 19.8364 21.6004 19.1999V7.1999C21.6004 6.56338 21.3475 5.95293 20.8974 5.50285C20.4474 5.05276 19.8369 4.7999 19.2004 4.7999H18.0004V3.5999C18.0004 3.28164 17.874 2.97642 17.6489 2.75137C17.4239 2.52633 17.1186 2.3999 16.8004 2.3999C16.4821 2.3999 16.1769 2.52633 15.9519 2.75137C15.7268 2.97642 15.6004 3.28164 15.6004 3.5999V4.7999H8.40039V3.5999C8.40039 3.28164 8.27396 2.97642 8.04892 2.75137C7.82387 2.52633 7.51865 2.3999 7.20039 2.3999ZM7.20039 8.3999C6.88213 8.3999 6.57691 8.52633 6.35186 8.75137C6.12682 8.97642 6.00039 9.28164 6.00039 9.5999C6.00039 9.91816 6.12682 10.2234 6.35186 10.4484C6.57691 10.6735 6.88213 10.7999 7.20039 10.7999H16.8004C17.1186 10.7999 17.4239 10.6735 17.6489 10.4484C17.874 10.2234 18.0004 9.91816 18.0004 9.5999C18.0004 9.28164 17.874 8.97642 17.6489 8.75137C17.4239 8.52633 17.1186 8.3999 16.8004 8.3999H7.20039Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const NumberIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.092 3.63611C11.4007 3.71345 11.666 3.91026 11.8296 4.18324C11.9932 4.45621 12.0417 4.783 11.9644 5.09171L11.4364 7.20011H14.9644L15.6364 4.50851C15.6738 4.35468 15.7412 4.20976 15.8348 4.0821C15.9285 3.95445 16.0464 3.84658 16.1819 3.76472C16.3174 3.68285 16.4678 3.6286 16.6243 3.6051C16.7809 3.58159 16.9405 3.5893 17.0941 3.62777C17.2476 3.66624 17.3921 3.73471 17.5191 3.82924C17.646 3.92378 17.7531 4.0425 17.834 4.17858C17.9149 4.31466 17.968 4.4654 17.9904 4.62211C18.0128 4.77883 18.004 4.93843 17.9644 5.09171L17.4364 7.20011H20.4004C20.7186 7.20011 21.0239 7.32654 21.2489 7.55158C21.474 7.77663 21.6004 8.08185 21.6004 8.40011C21.6004 8.71837 21.474 9.02359 21.2489 9.24864C21.0239 9.47368 20.7186 9.60011 20.4004 9.60011H16.8364L15.6364 14.4001H18.0004C18.3186 14.4001 18.6239 14.5265 18.8489 14.7516C19.074 14.9766 19.2004 15.2819 19.2004 15.6001C19.2004 15.9184 19.074 16.2236 18.8489 16.4486C18.6239 16.6737 18.3186 16.8001 18.0004 16.8001H15.0364L14.3644 19.4905C14.3284 19.6457 14.2619 19.7922 14.1687 19.9214C14.0755 20.0506 13.9575 20.16 13.8216 20.2431C13.6857 20.3263 13.5346 20.3815 13.3771 20.4056C13.2196 20.4298 13.0589 20.4223 12.9044 20.3836C12.7498 20.345 12.6045 20.276 12.4769 20.1806C12.3493 20.0852 12.242 19.9653 12.1612 19.828C12.0804 19.6907 12.0277 19.5387 12.0063 19.3808C11.9849 19.2229 11.9951 19.0624 12.0364 18.9085L12.5644 16.8001H9.03639L8.36439 19.4905C8.3284 19.6457 8.26188 19.7922 8.16868 19.9214C8.07549 20.0506 7.9575 20.16 7.82159 20.2431C7.68569 20.3263 7.53459 20.3815 7.37711 20.4056C7.21963 20.4298 7.05892 20.4223 6.90436 20.3836C6.7498 20.345 6.60448 20.276 6.47688 20.1806C6.34928 20.0852 6.24195 19.9653 6.16116 19.828C6.08036 19.6907 6.02772 19.5387 6.0063 19.3808C5.98488 19.2229 5.99511 19.0624 6.03639 18.9085L6.56439 16.8001H3.60039C3.28213 16.8001 2.97691 16.6737 2.75186 16.4486C2.52682 16.2236 2.40039 15.9184 2.40039 15.6001C2.40039 15.2819 2.52682 14.9766 2.75186 14.7516C2.97691 14.5265 3.28213 14.4001 3.60039 14.4001H7.16439L8.36439 9.60011H6.00039C5.68213 9.60011 5.37691 9.47368 5.15186 9.24864C4.92682 9.02359 4.80039 8.71837 4.80039 8.40011C4.80039 8.08185 4.92682 7.77663 5.15186 7.55158C5.37691 7.32654 5.68213 7.20011 6.00039 7.20011H8.96439L9.63639 4.50851C9.71373 4.1998 9.91054 3.93446 10.1835 3.77086C10.4565 3.60725 10.7833 3.55878 11.092 3.63611ZM10.8364 9.60011L9.63639 14.4001H13.162L14.362 9.60011H10.8376H10.8364Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const LikertIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.40039 13.2001C2.40039 12.8818 2.52682 12.5766 2.75186 12.3516C2.97691 12.1265 3.28213 12.0001 3.60039 12.0001H6.00039C6.31865 12.0001 6.62387 12.1265 6.84892 12.3516C7.07396 12.5766 7.20039 12.8818 7.20039 13.2001V19.2001C7.20039 19.5184 7.07396 19.8236 6.84892 20.0486C6.62387 20.2737 6.31865 20.4001 6.00039 20.4001H3.60039C3.28213 20.4001 2.97691 20.2737 2.75186 20.0486C2.52682 19.8236 2.40039 19.5184 2.40039 19.2001V13.2001ZM9.60039 8.4001C9.60039 8.08184 9.72682 7.77661 9.95186 7.55157C10.1769 7.32653 10.4821 7.2001 10.8004 7.2001H13.2004C13.5187 7.2001 13.8239 7.32653 14.0489 7.55157C14.274 7.77661 14.4004 8.08184 14.4004 8.4001V19.2001C14.4004 19.5184 14.274 19.8236 14.0489 20.0486C13.8239 20.2737 13.5187 20.4001 13.2004 20.4001H10.8004C10.4821 20.4001 10.1769 20.2737 9.95186 20.0486C9.72682 19.8236 9.60039 19.5184 9.60039 19.2001V8.4001ZM16.8004 4.8001C16.8004 4.48184 16.9268 4.17661 17.1519 3.95157C17.3769 3.72653 17.6821 3.6001 18.0004 3.6001H20.4004C20.7186 3.6001 21.0239 3.72653 21.2489 3.95157C21.474 4.17661 21.6004 4.48184 21.6004 4.8001V19.2001C21.6004 19.5184 21.474 19.8236 21.2489 20.0486C21.0239 20.2737 20.7186 20.4001 20.4004 20.4001H18.0004C17.6821 20.4001 17.3769 20.2737 17.1519 20.0486C16.9268 19.8236 16.8004 19.5184 16.8004 19.2001V4.8001Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const GroupIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 18H21H9Z" className="svgicon-tprimary fill" />
    <path
      d="M9 6H21M9 12H21M9 18H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon-tprimary stroke"
    />
    <path
      d="M3 6V18"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon-tprimary stroke"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 4V16V4Z" className="svgicon-tprimary fill" />
    <path
      d="M4 16V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V16M16 8L12 4M12 4L8 8M12 4V16"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon-tprimary stroke"
      strokeLinejoin="round"
    />
  </svg>
);

export const GridIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99961 3.6001C5.36309 3.6001 4.75264 3.85295 4.30255 4.30304C3.85247 4.75313 3.59961 5.36358 3.59961 6.0001V8.4001C3.59961 9.03662 3.85247 9.64707 4.30255 10.0972C4.75264 10.5472 5.36309 10.8001 5.99961 10.8001H8.39961C9.03613 10.8001 9.64658 10.5472 10.0967 10.0972C10.5468 9.64707 10.7996 9.03662 10.7996 8.4001V6.0001C10.7996 5.36358 10.5468 4.75313 10.0967 4.30304C9.64658 3.85295 9.03613 3.6001 8.39961 3.6001H5.99961ZM5.99961 13.2001C5.36309 13.2001 4.75264 13.453 4.30255 13.903C3.85247 14.3531 3.59961 14.9636 3.59961 15.6001V18.0001C3.59961 18.6366 3.85247 19.2471 4.30255 19.6972C4.75264 20.1472 5.36309 20.4001 5.99961 20.4001H8.39961C9.03613 20.4001 9.64658 20.1472 10.0967 19.6972C10.5468 19.2471 10.7996 18.6366 10.7996 18.0001V15.6001C10.7996 14.9636 10.5468 14.3531 10.0967 13.903C9.64658 13.453 9.03613 13.2001 8.39961 13.2001H5.99961ZM13.1996 6.0001C13.1996 5.36358 13.4525 4.75313 13.9026 4.30304C14.3526 3.85295 14.9631 3.6001 15.5996 3.6001H17.9996C18.6361 3.6001 19.2466 3.85295 19.6967 4.30304C20.1468 4.75313 20.3996 5.36358 20.3996 6.0001V8.4001C20.3996 9.03662 20.1468 9.64707 19.6967 10.0972C19.2466 10.5472 18.6361 10.8001 17.9996 10.8001H15.5996C14.9631 10.8001 14.3526 10.5472 13.9026 10.0972C13.4525 9.64707 13.1996 9.03662 13.1996 8.4001V6.0001ZM13.1996 15.6001C13.1996 14.9636 13.4525 14.3531 13.9026 13.903C14.3526 13.453 14.9631 13.2001 15.5996 13.2001H17.9996C18.6361 13.2001 19.2466 13.453 19.6967 13.903C20.1468 14.3531 20.3996 14.9636 20.3996 15.6001V18.0001C20.3996 18.6366 20.1468 19.2471 19.6967 19.6972C19.2466 20.1472 18.6361 20.4001 17.9996 20.4001H15.5996C14.9631 20.4001 14.3526 20.1472 13.9026 19.6972C13.4525 19.2471 13.1996 18.6366 13.1996 18.0001V15.6001Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const TimeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0004 21.5999C14.5465 21.5999 16.9883 20.5885 18.7886 18.7881C20.589 16.9878 21.6004 14.546 21.6004 11.9999C21.6004 9.45382 20.589 7.01203 18.7886 5.21168C16.9883 3.41133 14.5465 2.3999 12.0004 2.3999C9.45431 2.3999 7.01251 3.41133 5.21217 5.21168C3.41182 7.01203 2.40039 9.45382 2.40039 11.9999C2.40039 14.546 3.41182 16.9878 5.21217 18.7881C7.01251 20.5885 9.45431 21.5999 12.0004 21.5999ZM13.2004 7.1999C13.2004 6.88164 13.074 6.57642 12.8489 6.35137C12.6239 6.12633 12.3187 5.9999 12.0004 5.9999C11.6821 5.9999 11.3769 6.12633 11.1519 6.35137C10.9268 6.57642 10.8004 6.88164 10.8004 7.1999V11.9999C10.8005 12.3181 10.9269 12.6233 11.152 12.8483L14.5456 16.2431C14.6571 16.3546 14.7894 16.443 14.9351 16.5034C15.0808 16.5637 15.2369 16.5948 15.3946 16.5948C15.5523 16.5948 15.7084 16.5637 15.8541 16.5034C15.9997 16.443 16.1321 16.3546 16.2436 16.2431C16.3551 16.1316 16.4435 15.9992 16.5039 15.8536C16.5642 15.7079 16.5953 15.5518 16.5953 15.3941C16.5953 15.2364 16.5642 15.0803 16.5039 14.9346C16.4435 14.789 16.3551 14.6566 16.2436 14.5451L13.2004 11.5031V7.1999Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const StatementIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.7998 4.80039C4.7998 4.16387 5.05266 3.55342 5.50275 3.10333C5.95284 2.65325 6.56329 2.40039 7.1998 2.40039H12.703C13.3395 2.40053 13.9498 2.65347 14.3998 3.10359L18.4966 7.20039C18.9467 7.65037 19.1997 8.26072 19.1998 8.89719V19.2004C19.1998 19.8369 18.9469 20.4474 18.4969 20.8974C18.0468 21.3475 17.4363 21.6004 16.7998 21.6004H7.1998C6.56329 21.6004 5.95284 21.3475 5.50275 20.8974C5.05266 20.4474 4.7998 19.8369 4.7998 19.2004V4.80039ZM7.1998 12.0004C7.1998 11.6821 7.32623 11.3769 7.55128 11.1519C7.77632 10.9268 8.08155 10.8004 8.3998 10.8004H15.5998C15.9181 10.8004 16.2233 10.9268 16.4483 11.1519C16.6734 11.3769 16.7998 11.6821 16.7998 12.0004C16.7998 12.3187 16.6734 12.6239 16.4483 12.8489C16.2233 13.074 15.9181 13.2004 15.5998 13.2004H8.3998C8.08155 13.2004 7.77632 13.074 7.55128 12.8489C7.32623 12.6239 7.1998 12.3187 7.1998 12.0004ZM8.3998 15.6004C8.08155 15.6004 7.77632 15.7268 7.55128 15.9519C7.32623 16.1769 7.1998 16.4821 7.1998 16.8004C7.1998 17.1186 7.32623 17.4239 7.55128 17.6489C7.77632 17.874 8.08155 18.0004 8.3998 18.0004H15.5998C15.9181 18.0004 16.2233 17.874 16.4483 17.6489C16.6734 17.4239 16.7998 17.1186 16.7998 16.8004C16.7998 16.4821 16.6734 16.1769 16.4483 15.9519C16.2233 15.7268 15.9181 15.6004 15.5998 15.6004H8.3998Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const DateTimeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H18V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V3H8V2C8 1.45 7.55 1 7 1C6.45 1 6 1.45 6 2V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18 19H6C5.45 19 5 18.55 5 18V7H19V18C19 18.55 18.55 19 18 19Z"
      className="svgicon-tprimary fill"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18C13.3261 18 14.5979 17.4732 15.5355 16.5355C16.4732 15.5979 17 14.3261 17 13C17 11.6739 16.4732 10.4021 15.5355 9.46447C14.5979 8.52678 13.3261 8 12 8C10.6739 8 9.40215 8.52678 8.46447 9.46447C7.52678 10.4021 7 11.6739 7 13C7 14.3261 7.52678 15.5979 8.46447 16.5355C9.40215 17.4732 10.6739 18 12 18ZM12.625 10.5C12.625 10.3342 12.5592 10.1753 12.4419 10.0581C12.3247 9.94085 12.1658 9.875 12 9.875C11.8342 9.875 11.6753 9.94085 11.5581 10.0581C11.4408 10.1753 11.375 10.3342 11.375 10.5V13C11.375 13.1657 11.4409 13.3247 11.5581 13.4419L13.3256 15.21C13.3837 15.2681 13.4526 15.3141 13.5285 15.3456C13.6044 15.377 13.6857 15.3932 13.7678 15.3932C13.8499 15.3932 13.9313 15.377 14.0071 15.3456C14.083 15.3141 14.1519 15.2681 14.21 15.21C14.2681 15.1519 14.3141 15.083 14.3456 15.0071C14.377 14.9313 14.3932 14.8499 14.3932 14.7678C14.3932 14.6857 14.377 14.6044 14.3456 14.5285C14.3141 14.4526 14.2681 14.3837 14.21 14.3256L12.625 12.7413V10.5Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const ScoreIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0004 21.6004C14.5465 21.6004 16.9883 20.589 18.7886 18.7886C20.589 16.9883 21.6004 14.5465 21.6004 12.0004C21.6004 9.45431 20.589 7.01251 18.7886 5.21217C16.9883 3.41182 14.5465 2.40039 12.0004 2.40039C9.45431 2.40039 7.01251 3.41182 5.21217 5.21217C3.41182 7.01251 2.40039 9.45431 2.40039 12.0004C2.40039 14.5465 3.41182 16.9883 5.21217 18.7886C7.01251 20.589 9.45431 21.6004 12.0004 21.6004ZM16.4488 10.4488C16.6674 10.2225 16.7883 9.91935 16.7856 9.60471C16.7829 9.29007 16.6567 8.9891 16.4342 8.76661C16.2117 8.54412 15.9107 8.41792 15.5961 8.41518C15.2814 8.41245 14.9783 8.5334 14.752 8.75199L10.8004 12.7036L9.24879 11.152C9.02247 10.9334 8.71934 10.8124 8.40471 10.8152C8.09007 10.8179 7.7891 10.9441 7.56661 11.1666C7.34412 11.3891 7.21792 11.6901 7.21518 12.0047C7.21245 12.3193 7.3334 12.6225 7.55199 12.8488L9.95199 15.2488C10.177 15.4738 10.4822 15.6001 10.8004 15.6001C11.1186 15.6001 11.4238 15.4738 11.6488 15.2488L16.4488 10.4488Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const SliderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="svgicon-tprimary fill"
  >
    <path d="M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" />
  </svg>
);

export const DropdownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.35134 8.75111C6.57638 8.52615 6.88155 8.39977 7.19974 8.39977C7.51794 8.39977 7.82311 8.52615 8.04814 8.75111L11.9997 12.7027L15.9513 8.75111C16.062 8.6365 16.1945 8.54508 16.3409 8.48219C16.4873 8.4193 16.6447 8.3862 16.8041 8.38481C16.9634 8.38343 17.1214 8.41379 17.2689 8.47413C17.4164 8.53446 17.5503 8.62357 17.663 8.73624C17.7757 8.84891 17.8648 8.98289 17.9251 9.13037C17.9855 9.27784 18.0158 9.43586 18.0144 9.59519C18.0131 9.75453 17.98 9.91199 17.9171 10.0584C17.8542 10.2048 17.7628 10.3372 17.6481 10.4479L12.8481 15.2479C12.6231 15.4729 12.3179 15.5993 11.9997 15.5993C11.6815 15.5993 11.3764 15.4729 11.1513 15.2479L6.35134 10.4479C6.12638 10.2229 6 9.91771 6 9.59951C6 9.28131 6.12638 8.97614 6.35134 8.75111Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const CalculatedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="svgicon-tprimary fill"
  >
    <path
      fillRule="evenodd"
      d="M6.32 1.827a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V4.757c0-1.47 1.073-2.756 2.57-2.93ZM7.5 11.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H8.25Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75H8.25Zm1.748-6a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.007Zm-.75 3a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.007Zm1.754-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.008Zm1.748-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-8.25-6A.75.75 0 0 1 8.25 6h7.5a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-.75Zm9 9a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-2.25Z"
      clipRule="evenodd"
    />
  </svg>
);

export const RepeatedDataIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="svgicon-tprimary fill"
  >
    <path
      fillRule="evenodd"
      d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
      clipRule="evenodd"
    />
  </svg>
);

export const SummaryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0867 12.5004C20.964 14.7316 20.0234 16.8467 18.4351 18.4351C16.7285 20.1416 14.4139 21.1004 12.0004 21.1004C9.58692 21.1004 7.2723 20.1416 5.56572 18.4351C3.85914 16.7285 2.90039 14.4139 2.90039 12.0004C2.90039 9.58692 3.85914 7.2723 5.56572 5.56572C7.15407 3.97736 9.26914 3.03682 11.5004 2.91412V12.0004V12.5004H12.0004H21.0867Z"
      className="svgicon-tprimary fill stroke"
    />
    <path
      d="M14.4004 2.70312C16.0607 3.13328 17.5758 3.99966 18.7886 5.21247C20.0015 6.42528 20.8678 7.94037 21.298 9.60073H14.4004V2.70312Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const RandomizeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6.75H5.16229C6.11734 6.75 7.05859 6.97798 7.90778 7.41499C8.75698 7.852 9.48959 8.48542 10.0447 9.26257L13.9553 14.7374C14.5104 15.5146 15.243 16.148 16.0922 16.585C16.9414 17.022 17.8827 17.25 18.8377 17.25H21.75"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon-tprimary stroke"
    />
    <path
      d="M19.5 4.5L21.75 6.75L19.5 9"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon-tprimary stroke"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 15L21.75 17.25L19.5 19.5"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon-tprimary stroke"
      strokeLinejoin="round"
    />
    <path
      d="M14.3223 8.79919C14.8854 8.15552 15.5797 7.63969 16.3585 7.28627C17.1373 6.93285 17.9827 6.75 18.838 6.75H21.7503"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon-tprimary stroke"
      strokeLinejoin="round"
    />
    <path
      d="M3 17.2504H5.16229C6.01755 17.2504 6.86293 17.0675 7.64175 16.7141C8.42057 16.3607 9.11484 15.8448 9.67801 15.2012"
      className="svgicon-tprimary stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EligibilityIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 10.925L18.1 12.3C17.9167 12.4833 17.6875 12.5792 17.4125 12.5875C17.1375 12.5958 16.9 12.5 16.7 12.3C16.5167 12.1167 16.425 11.8833 16.425 11.6C16.425 11.3167 16.5167 11.0833 16.7 10.9L18.075 9.5L16.7 8.125C16.5167 7.94167 16.425 7.7125 16.425 7.4375C16.425 7.1625 16.5167 6.925 16.7 6.725C16.9 6.525 17.1375 6.425 17.4125 6.425C17.6875 6.425 17.925 6.525 18.125 6.725L19.5 8.1L20.875 6.7C21.0583 6.5 21.2875 6.4 21.5625 6.4C21.8375 6.4 22.075 6.5 22.275 6.7C22.475 6.9 22.575 7.1375 22.575 7.4125C22.575 7.6875 22.475 7.925 22.275 8.125L20.9 9.5L22.3 10.9C22.5 11.1 22.5958 11.3333 22.5875 11.6C22.5792 11.8667 22.475 12.1 22.275 12.3C22.075 12.4833 21.8417 12.5792 21.575 12.5875C21.3083 12.5958 21.075 12.5 20.875 12.3L19.5 10.925ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM1 18V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20H3C2.45 20 1.97917 19.8042 1.5875 19.4125C1.19583 19.0208 1 18.55 1 18Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const RepeatedMeasureIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.0005C10.75 22.0005 9.57917 21.763 8.4875 21.288C7.39583 20.813 6.44583 20.1713 5.6375 19.363C4.82917 18.5547 4.1875 17.6047 3.7125 16.513C3.2375 15.4213 3 14.2505 3 13.0005C3 11.7505 3.2375 10.5797 3.7125 9.488C4.1875 8.39633 4.82917 7.44633 5.6375 6.638C6.44583 5.82967 7.39583 5.188 8.4875 4.713C9.57917 4.238 10.75 4.0005 12 4.0005H12.15L11.3 3.1505C11.1167 2.96717 11.025 2.738 11.025 2.463C11.025 2.188 11.1167 1.9505 11.3 1.7505C11.5 1.5505 11.7375 1.44633 12.0125 1.438C12.2875 1.42967 12.525 1.5255 12.725 1.7255L15.3 4.3005C15.4833 4.48383 15.575 4.71717 15.575 5.0005C15.575 5.28383 15.4833 5.51717 15.3 5.7005L12.725 8.2755C12.525 8.4755 12.2875 8.57133 12.0125 8.563C11.7375 8.55467 11.5 8.4505 11.3 8.2505C11.1167 8.0505 11.025 7.813 11.025 7.538C11.025 7.263 11.1167 7.03383 11.3 6.8505L12.15 6.0005H12C10.05 6.0005 8.39583 6.67967 7.0375 8.038C5.67917 9.39633 5 11.0505 5 13.0005C5 14.9505 5.67917 16.6047 7.0375 17.963C8.39583 19.3213 10.05 20.0005 12 20.0005C13.7667 20.0005 15.3083 19.4255 16.625 18.2755C17.9417 17.1255 18.7167 15.6755 18.95 13.9255C18.9833 13.6588 19.1 13.438 19.3 13.263C19.5 13.088 19.7333 13.0005 20 13.0005C20.2667 13.0005 20.5 13.0838 20.7 13.2505C20.9 13.4172 20.9833 13.6255 20.95 13.8755C20.7167 16.1922 19.75 18.1255 18.05 19.6755C16.35 21.2255 14.3333 22.0005 12 22.0005Z"
      fill="black"
    />
    <path
      d="M8 13C8 12.8674 8.05268 12.7402 8.14645 12.6464C8.24021 12.5527 8.36739 12.5 8.5 12.5H9.5C9.63261 12.5 9.75979 12.5527 9.85355 12.6464C9.94732 12.7402 10 12.8674 10 13V15.5C10 15.6326 9.94732 15.7598 9.85355 15.8536C9.75979 15.9473 9.63261 16 9.5 16H8.5C8.36739 16 8.24021 15.9473 8.14645 15.8536C8.05268 15.7598 8 15.6326 8 15.5V13ZM11 11C11 10.8674 11.0527 10.7402 11.1464 10.6464C11.2402 10.5527 11.3674 10.5 11.5 10.5H12.5C12.6326 10.5 12.7598 10.5527 12.8536 10.6464C12.9473 10.7402 13 10.8674 13 11V15.5C13 15.6326 12.9473 15.7598 12.8536 15.8536C12.7598 15.9473 12.6326 16 12.5 16H11.5C11.3674 16 11.2402 15.9473 11.1464 15.8536C11.0527 15.7598 11 15.6326 11 15.5V11ZM14 9.5C14 9.36739 14.0527 9.24021 14.1464 9.14645C14.2402 9.05268 14.3674 9 14.5 9H15.5C15.6326 9 15.7598 9.05268 15.8536 9.14645C15.9473 9.24021 16 9.36739 16 9.5V15.5C16 15.6326 15.9473 15.7598 15.8536 15.8536C15.7598 15.9473 15.6326 16 15.5 16H14.5C14.3674 16 14.2402 15.9473 14.1464 15.8536C14.0527 15.7598 14 15.6326 14 15.5V9.5Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const MedicationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    fill="none"
  >
    <path
      d="m646.84-356.31 112.93-113.54q28.92-28.92 44.57-66.44Q820-573.82 820-615q0-85.64-59.72-145.32Q700.57-820 614.87-820q-41.02 0-78.56 15.66-37.54 15.65-66.46 44.57L356.31-646.84l290.53 290.53ZM345.13-140q41.02 0 78.56-15.66 37.54-15.65 66.46-44.57l113.54-112.93-290.53-290.53-112.93 113.54q-28.92 28.92-44.57 66.44Q140-386.18 140-345q0 85.64 59.72 145.32Q259.43-140 345.13-140Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.40039 2.4001C7.76387 2.4001 7.15342 2.65295 6.70333 3.10304C6.25325 3.55313 6.00039 4.16358 6.00039 4.8001V19.2001C6.00039 19.8366 6.25325 20.4471 6.70333 20.8972C7.15342 21.3472 7.76387 21.6001 8.40039 21.6001H15.6004C16.2369 21.6001 16.8474 21.3472 17.2974 20.8972C17.7475 20.4471 18.0004 19.8366 18.0004 19.2001V4.8001C18.0004 4.16358 17.7475 3.55313 17.2974 3.10304C16.8474 2.65295 16.2369 2.4001 15.6004 2.4001H8.40039ZM8.40039 4.8001H15.6004V15.6001H8.40039V4.8001ZM10.8004 18.0001C10.8004 17.6818 10.9268 17.3766 11.1519 17.1516C11.3769 16.9265 11.6821 16.8001 12.0004 16.8001C12.3187 16.8001 12.6239 16.9265 12.8489 17.1516C13.074 17.3766 13.2004 17.6818 13.2004 18.0001C13.2004 18.3184 13.074 18.6236 12.8489 18.8486C12.6239 19.0737 12.3187 19.2001 12.0004 19.2001C11.6821 19.2001 11.3769 19.0737 11.1519 18.8486C10.9268 18.6236 10.8004 18.3184 10.8004 18.0001Z"
      className="svgicon-tprimary fill"
    />
  </svg>
);
